import { AgeConfirmation, IdDuplicated, PPersonalData, PPersonalDataRefactor, UiModal } from 'libs/raas-ui-react-components/src/components'
import { useState, useEffect, useContext, useRef } from 'react';
import { putAxios, deleteAxios } from 'services/api/api.service';
import { apiNames } from 'services/api/endpoint.service'
import { closeSession, IUserData, RaaSSession, SessionStorageItems } from 'services/user/user.session.service';
import { mutateData } from './PersonalData.service';
import useSession from 'hooks/useSession';
import useToast from 'hooks/useToast';
import PrivatePagesWrapper from 'components/PrivatePagesWrapper/PrivatePagesWrapper';
import { useNavigate } from 'react-router-dom';
import { PersonalDataUtils } from './PersonalData.utils';
import { removeItemStorage } from 'services/util/sessionStorage.service';
import { getUserData } from 'services/user/user-micros.service';
import { useTranslation } from 'react-i18next';
import { dataCounter } from '../../../../../raas-ui-react-components/dist/types/components/atomic/ui-num-passengers/ui-num-passengers.model';

export enum EPathToNavigate {
  TRIP = "/trip",
  PROFILE = "/my-profile"
}


export const PersonalDataProfile = () => {
  const [t] = useTranslation('personalDataProfile');
  const [profileData, setProfileData] = useState(new ProfileData({}));
  const [mounted, setMount] = useState(false);
  const { setSession, setLogged, setUserConnected } = useSession();
  const [showDuplicateIDModal, setShowModal] = useState(false);
  const [showConfirmationIDModal, setShowModalAge] = useState(false);
  const [isUnder16, setIsUnder16] = useState(false);
  const { openToast } = useToast();
  const navigate = useNavigate();
  const [savedBirthDate, setSavedBirthDate] = useState('');


  let userData = new ProfileData({});

  /* REACT v.18 DOCUMENTATION:  Equivale a componentDidMount, componentDidUpdate y componentWillUnmount combinados.*/
  useEffect(() => {
    console.warn("[TRAZA] mounted", profileData);
    !userData.name && getData();
    return () => {
      console.warn("[TRAZA] unmounted");
    };
  }, []);

  /**
   * Función con el que tengo que obtener datos del usuario.
   */
  const getData = () => {
    getUserData((response: any) => {
      userData = new ProfileData(response.data);
      setUserConnected(response?.data);
      setSavedBirthDate(response.data.birthDate);
      setProfileData(userData);
    }, () => {
      openToast("error", t("literals.error"), t("literals.errorTryAgainLater"))
    })
  }
  /**
   * Función que lanzará un PUT para cambiar sus datos personales.
   * @param data {ProfileData} Datos del formulario 
   */
  const putPersonalData = (data: any) => {
    putAxios(apiNames.PROFMANAG, true, "/customers/profiles", data)
      .then((response: any) => {
        if (response?.data) {
          const params = new URLSearchParams(window?.location?.search);
          const path = params.get('goTo') || '/my-profile';
          path === EPathToNavigate.TRIP 
          ? tripFlow(path)
          : myProfileFlow(response.data, path) 
        }
      })
      .catch(((err: any) => {
        if (err.status === 409) {
          setShowModal(true);
        }else if(err?.data?.errors[0]?.message==="Invalid identification document"){
          openToast("error", t("literals.error"), t("PersonalDataUtils.literals.idinfo.documentType.passport.errormsg"))
        } 
        else {
          openToast("error", t("literals.error"), t("literals.errorTryAgainLater"))
        }
      }
      ))
  }

  const myProfileFlow = (profileData: any, path: string): void => {

    const dataValues = new ProfileData(profileData);
    setProfileData(dataValues);
    navigate(path);
  }

  const tripFlow  = (path: string) => {
    getUserDataInfoToUserWithAllInfo(path);
  } 

/**
   * Llamamos el getUserData para actualizar con todos lo datos del usuario, porque el putPersonalData no lleva todos, y fallan validaciones en el trip selector
   * 
   */
  const  getUserDataInfoToUserWithAllInfo = (path: string) => {
      
      getUserData((response: any) => {
        const dataValues = new ProfileData(response.data);
        setUserConnected(response?.data);
        setProfileData(dataValues);
        navigate(path);
      }, () => {
        openToast("error", t("literals.error"), t("literals.errorTryAgainLater"))
      })
    }

  
  /**
   * Funcion que recibo del componente p-personal-data-profile que contendrá todos los campos rellenos y válidos.
   * @param data Valores de todos los campos
   */
  const handleSaveData = (data: any) => {
    if(isUnder16) {
        const detailWithoutBirthday = {...data.detail, birthDate :savedBirthDate};
        putPersonalData(detailWithoutBirthday);
    } else {        
        putPersonalData(data.detail);
    }
    
  }

  const handleDeleteAccount = () => {
    navigate('/delete-account')
  }

  const handleRessetPassword = () => {
    deleteAccount(() => {
      setShowModal(false);
      navigate("/reset-password")



    })
  }

  const hadleAssist = () => {
    deleteAccount(() => {
      window.location.pathname = "/ayuda";
      setShowModal(false);
    })
  }

  const handleCloseModal = () => {
    setShowModal(false);
  }

  const deleteAccount = (callback: Function) => {
    deleteAxios(apiNames.IDENTITY, true, "/customers/accounts").then((response: any) => {
      // TODO - SESSION CLOSE, REMAKE THE USE SESSION, WITH ALL THIS 3 LINES.
      setLogged(false);
      setSession({} as RaaSSession);
      setUserConnected({} as IUserData);
      removeItemStorage(SessionStorageItems.RAAS_USER);
      closeSession();

      callback(response);
    }).catch((error: any) => {
      callback(error);
    })
  }

  const handleLessAge = (ev: CustomEvent) => {
    setShowModalAge(ev.detail);
    setIsUnder16(ev.detail)
  }

  const handleUnderstoodClick = (ev: CustomEvent) => {
    setShowModalAge(false);
  }



  return (
    <>
      <PPersonalDataRefactor
        userData={profileData}
        onShowlessAge={handleLessAge}
        onSaveData={handleSaveData}
        onDeleteAccountEvent={handleDeleteAccount}
        literals={PersonalDataUtils(t).literals} />
      {/* <PPersonalData personaldatavalues={profileData} onSaveData={handleSaveData} onDeleteAccount={handleDeleteAccount} /> */}
      <PrivatePagesWrapper></PrivatePagesWrapper>
      <UiModal open={showDuplicateIDModal}>
        <IdDuplicated
          onNeedAssist={hadleAssist}
          onNewPassword={handleRessetPassword}
          onCloseModal={handleCloseModal}
        />
      </UiModal>
      <UiModal open={showConfirmationIDModal} blockOverlay={true}>
        <AgeConfirmation
          literals={{
            title:  t("literals.title"),
            description: t("literals.description"),
            buttonText: t("literals.buttonText"),
            confirmationButton: t("literals.confirmationButton"),
            secondaryButtonText: t("literals.secondaryButtonText"),
          }}
          confirmation={true}
          onUnderstood={handleUnderstoodClick}
        />
      </UiModal>
    </>
  )
}
{/* <PPersonalData personaldataValues={profileData} onSaveData={handleSaveData} /> */ }

export class ProfileData {
  email?: string;
  name?: string;
  surname?: string;
  surname2?: string;
  prefixNumber?: string;
  phoneNumber?: string;
  day?: string;
  month?: string;
  year?: string;
  identificationDocument?:{
    type?: string
    value?: string
  };
  mailingAddress?: any;
  constructor(data: any) {

    try {
      const {
        customerFullName, birthDate, email, identificationDocument, phone, mailingAddress
      } = data;
      let auxIdentificationDocument
      if(identificationDocument?.type=='PASS'){
        auxIdentificationDocument={
          type: 'Pasaporte',value: identificationDocument?.value
        }
      }else{
        auxIdentificationDocument={
          type: identificationDocument?.type,
          value: identificationDocument?.value
        }
      }
      this.day = !!birthDate ? birthDate.split('-')[2] : '';
      this.month = !!birthDate ? birthDate.split('-')[1] : '';
      this.year = !!birthDate ? birthDate.split('-')[0] : '';
      this.email = email;
      this.name = customerFullName && customerFullName.name;
      this.surname = customerFullName && customerFullName.firstSurname;
      this.surname2 = customerFullName && customerFullName.secondSurname;
      this.prefixNumber = phone && phone.prefix!=null ?phone.prefix.split('+')[1]:"null";
      this.phoneNumber = phone && phone.number;
      this.identificationDocument =  auxIdentificationDocument;
      this.mailingAddress = mailingAddress;
    } catch (error) {
      console.warn('Ha habido un error al mapear ProfileData', error);
    }
  }
}
